import { AllowObservableContextBaseConstruct } from '../../../../core/observable/context/base/constructor';
import { ObservableContextBase } from '../../../../core/observable/context/base/implementation';
import { OBSERVABLE_CONTEXT_BASE_PRIVATE } from '../../../../core/observable/context/base/privates';
import { NotificationsObservableDispatch } from '../functions';
export function NewNotificationsObservableContext(notificationsObservable) {
    AllowObservableContextBaseConstruct(true);
    const context = new NotificationsObservableContext(notificationsObservable);
    AllowObservableContextBaseConstruct(false);
    return context;
}
export function NotificationsObservableContextEmit(instance, notification) {
    NotificationsObservableDispatch(instance[OBSERVABLE_CONTEXT_BASE_PRIVATE].observable, notification.name, notification.value, notification);
}
export function NotificationsObservableContextDispatch(instance, name, value) {
    NotificationsObservableDispatch(instance[OBSERVABLE_CONTEXT_BASE_PRIVATE].observable, name, value);
}
export class NotificationsObservableContext extends ObservableContextBase {
    constructor(observable) {
        super(observable);
    }
    get observable() {
        return super.observable;
    }
    emit(value) {
        NotificationsObservableContextEmit(this, value);
    }
    dispatch(name, value) {
        NotificationsObservableContextDispatch(this, name, value);
    }
}
//# sourceMappingURL=implementation.js.map